// Shamelessly stolen from https://codepen.io/VincentMLSE/pen/OJdWqpV
import cn from 'classnames';
import styles from './loading.module.css';

export interface LoadingProps {
	testId?: string;
	className?: string;
}

const Loading = (props: LoadingProps) => {
	const { testId = 'Loading', className = '' } = props;

	return (
		<div
			data-testid={testId}
			className={cn(styles['spinner_container'], className)}
			role="status"
			aria-label="Loading..."
		>
			<i className={styles['spinner_item']}></i>
			<i className={styles['spinner_item']}></i>
		</div>
	);
};

export default Loading;
